/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import MinimalModal from 'app/components/Modals/MinimalModal.jsx';
import CreditCardModal from 'app/components/Subscription/CreditCardModal.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import * as _ from 'underscore';
import PricingModule from 'app/mixins/PricingModule.jsx';
import GetPlanData from 'app/utility/GetPlanData.js';
import CompactSubscriptionModal from 'app/components/Subscription/CompactSubscriptionModal.jsx';
import { Link } from 'react-router-dom';
import Modal from 'app/components/common/Modal.jsx';


class SubscriptionPauseModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            firstPullFlag: props.app.config.constants.FIRSTPULL_SINGLE,
            selectedPlan: {},
            showCCModal: false,
            downgrading: false,
            showAlternatePlan: false
        };

        this.addPayment = this.addPayment.bind(this);
        this.renderPauseModal = this.renderPauseModal.bind(this);
        this.changeTerm = this.changeTerm.bind(this);
        this.generateSubUrl = this.generateSubUrl.bind(this);

    }

    componentDidMount() {

        this.props.getPlans();

        if (dataLayer) {
            dataLayer.push({
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {'step': 1, 'option': 'Resubscribe'}
                    }
                }
            });
        }

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Subscription Pause Modal'
            });
        }

    }

    componentDidUpdate(prevProps, prevState) {
        let plans = this.props.plans.details,
            constants = this.props.app.config.constants,
            downgrading = this.state.downgrading,
            showAlternatePlan = this.state.showAlternatePlan;

        if (!_.isEmpty(plans)) {
            if (this.props.app.configLoaded && this.props.app.userLoaded && this.props.app.firstLoad.SUB_FETCH_EXPIRED_PLAN) {
                if (_.isEmpty(this.state.selectedPlan)) {
                    // try to default to pro
                    let selectedPlan = {};
                    if (this.props.newSubscription !== undefined) {
                        selectedPlan = this.props.newSubscription;

                        if (!_.isEmpty(this.props.plans.expiredPlan)) {
                            let inputsRequired = parseInt(this.props.user.perms.resources.inputsInUse, 10),
                                outputsRequired = parseInt(this.props.user.perms.resources.outputsInUse, 10),
                                nextPlanAddOns = null,
                                nextPlanInputs = parseInt(this.props.plans.details[selectedPlan.level].limits.hardLimitInputs),
                                nextPlanOutputs = parseInt(this.props.plans.details[selectedPlan.level].limits.hardLimitOutputs);

                            if (Object.keys(this.props.plans.details[selectedPlan.level].addOnQuantity).length) {
                                nextPlanAddOns = this.props.plans.details[selectedPlan.level].addOnQuantity[constants.SUBSCRIPTION_ADDON_SOCIALS];
                            }

                            if (!_.isEmpty(this.props.plans.expiredPlan)) {
                                if (nextPlanAddOns) {
                                    if (selectedPlan.addOns) {
                                        let totalInputs = nextPlanInputs + (nextPlanAddOns.inputs * selectedPlan.addOns),
                                            totalOutputs = nextPlanOutputs + (nextPlanAddOns.outputs * selectedPlan.addOns);

                                        if (inputsRequired > totalInputs || outputsRequired > totalOutputs) {
                                            downgrading = true;
                                        }
                                    } else {
                                        if (inputsRequired > nextPlanInputs || outputsRequired > nextPlanOutputs) {
                                            downgrading = true;
                                        }
                                    }
                                } else {
                                    if (inputsRequired > nextPlanInputs || outputsRequired > nextPlanOutputs) {
                                        downgrading = true;
                                    }
                                }

                                if (selectedPlan.level !== this.props.plans.expiredPlan.planLevel) {
                                    showAlternatePlan = true;
                                }

                            }


                        }
                    } else if (!_.isEmpty(this.props.plans.expiredPlan)) {
                        selectedPlan = {
                            level: parseInt(this.props.plans.expiredPlan.planLevel),
                            term: parseInt(this.props.plans.expiredPlan.planTerm)
                        };
                        if (!_.isEmpty(this.props.plans.expiredPlan.addOns) && this.props.plans.expiredPlan.addOns.add_on_social !== undefined) {
                            selectedPlan.addOns = parseInt(this.props.plans.expiredPlan.addOns.add_on_social.qty);
                        }
                    }

                    this.setState({
                        selectedPlan: selectedPlan,
                        downgrading,
                        showAlternatePlan
                    });

                }

            }
        }

        if ((prevProps.app.loading.SUB_CREATE === true && this.props.app.loading.SUB_CREATE === false) ||
            (prevProps.app.loading.SUB_UPDATE === true && this.props.app.loading.SUB_UPDATE === false)) {
            // subscription has been updated reload the important bits
            this.props.getUser();
            this.props.getUserPerms();
            this.props.getRoutes();
            this.props.getSocials(true);
            this.props.getSubscription();
            this.props.closeAllModals();

            // track some stuff too
            let subscription = this.props.plans.current,
                products = [];

            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: 'Subscription Pause Modal - Resubscribe',
                    event_data: {
                        subscription: subscription.planName
                    }
                });
            }
            // if (dataLayer) {
            //     let planDetail = GetPlanData.lookupDetails(
            //         this.props.plans.current.planLevel,
            //         this.props.plans.current.planTerm
            //     );
            //
            //     products.push({
            //         'name': subscription.planName,     // Name or ID is required.
            //         'price': subscription.price,
            //         'quantity': 1,
            //         'variant': 'resubscribe'
            //     });
            //
            //     dataLayer.push({
            //         'event': 'purchase',
            //         'ecommerce': {
            //             'purchase': {
            //                 'actionField': {
            //                     'id': subscription.uuid, // Transaction ID. Required for purchases and refunds.
            //                     'revenue': subscription.price
            //                 },
            //                 'products': products
            //             }
            //         },
            //         // GA4 params
            //         'transaction_id': subscription.uuid,
            //         'value': subscription.price,
            //         'items': [{
            //             item_id: planDetail.plan_id,
            //             item_name: planDetail.plan_name,
            //             item_variant: 'resubscribe',
            //             quantity: 1,
            //             price: subscription.price
            //         }]
            //     });
            // }

            if (gtag) {
                let promoData = this.props.getPersistedData('gaPromo');

                gtag('event', 'purchase', {
                    transaction_id: subscription.uuid,
                    value: 1.00,
                    currency: 'USD',
                    items: [
                        {
                            item_id: 'dlvrit_1',
                            item_name: 'dlvr.it premium plan',
                            item_variant: 'Resubscribe',
                            price: 1.00,
                            quantity: 1,
                            promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                            promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                        }
                    ],

                });

                if (this.props.recordEvent) {
                    this.props.recordEvent({
                        pub_id: this.props.user.detail.id,
                        event_name: 'Resubscribe',
                        event_data: {
                            promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                            promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                        }
                    })
                }

                this.props.clearPersistedData('gaPromo');
            }

        }

    }

    componentWillUnmount() {
        this.props.resetCoupon();

        if (this.props.user.detail.hasSnapshot && !window.sessionStorage.getItem('hasSeenSnapshotModal')) {
            window.sessionStorage.setItem('hasSeenSnapshotModal', true);
        }

    }

    addPayment(e) {
        e.preventDefault();

        // begin_checkout event for GA4 called when the credit card modal pops
        let promoData = this.props.getPersistedData('gaPromo');

        if (gtag) {
            gtag('event', 'begin_checkout', {
                currency: 'USD',
                value: 1.0,
                items: [{
                    item_id: 'dlvrit_1',
                    item_name: 'dlvr.it premium plan',
                    item_variant: 'Resubscribe',
                    price: 1.0,
                    quantity: 1,
                    promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                    promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                }],

            });
        }

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Start Resubscription',
                event_data: {
                    promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                    promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                }
            })
        }

        this.setState({
            showCCModal: true
        });

    }

    changeTerm(e) {
        let term = e.currentTarget.dataset.term,
            selectedPlan = this.state.selectedPlan;

        selectedPlan.term = term;

        this.setState({
            selectedPlan
        });

    }

    generateSubUrl() {
        let linkUrl = '/account/subscription/new';

        if (Object.keys(this.props.plans.expiredPlan).length) {
            linkUrl += `?plan=${this.props.plans.expiredPlan.planLevel}`;
            if (!_.isEmpty(this.props.plans.expiredPlan.addOns)) {
                if (this.props.plans.expiredPlan.addOns.add_on_social !== undefined) {
                    linkUrl += `&addons=${this.props.plans.expiredPlan.addOns.add_on_social.qty}`;
                }
            }
        }

        return linkUrl;
    }

    renderPauseModal() {
        let constants = this.props.app.config.constants,
            content = null;

        if (_.isEmpty(this.props.plans.expiredPlan) || _.isEmpty(this.props.user) || _.isEmpty(this.state.selectedPlan)) {
            return null;
        }

        let headline = "Posting paused",
            mainCopy = "Your recent payment failed. You're now on the free plan.",
            confirmLabel = "Restart unlimited posting",
            cancelLabel = "Continue with limits",
            cancelAction = (e) => {
                e.preventDefault();
                this.props.updateSubscription({
                    level: constants.PUB_LEVEL_1,
                    isHammertime: true
                });
            };

        if (this.props.user.detail.hasSnapshot) {
            headline = "Payment failed";
            mainCopy = "You're now on the limited free plan.";
            cancelLabel = "Continue with limits";
            cancelAction = (e) => {
                e.preventDefault();
                this.props.clearSnapshot();
                this.props.updateSubscription({
                    level: constants.PUB_LEVEL_1,
                });
            }
        }

        content = (
            <CompactSubscriptionModal
                {...this.props}
                headline={headline}
                mainCopy={mainCopy}
                confirmLabel={confirmLabel}
                confirmAction={(e) => {
                    e.preventDefault()
                    this.setState({
                        showCCModal: true
                    });
                }}
                cancelLabel={cancelLabel}
                cancelAction={cancelAction}
                closeAction={(e) => {
                    e.preventDefault();
                    this.props.updateSubscription({
                        level: constants.PUB_LEVEL_1,
                    });
                }}/>
        );

        return (
            <Modal
                content={content}
                showClose={false}
                boxClass={"trial-ended-box"}
                mainClass={"trial-ended-content"} />
        );
    }

    render() {

        if (this.state.showCCModal) {
            let addOns = null;

            if (this.state.selectedPlan.addOns > 0) {
                addOns = {
                    add_on_social: this.state.selectedPlan.addOns
                };
            }

            return (
                <CreditCardModal
                    {...this.props}
                    plan={this.state.selectedPlan.level}
                    username={this.props.user.detail.username}
                    planTerm={this.state.selectedPlan.term}
                    planPrice={this.state.selectedPlan.price}
                    firstPullFlag={this.state.firstPullFlag}
                    addOns={addOns}
                    changeTerm={this.changeTerm}
                    showClose={true}
                    closeAction={(e) => {
                        if (e) {
                            e.preventDefault();
                        }
                        let constants = this.props.app.config.constants;
                        this.props.updateSubscription({
                            level: constants.PUB_LEVEL_1,
                        });
                    }}
                    isHammertime={this.state.downgrading} />
            );
        } else {
            return this.renderPauseModal();
        }

    }
}

SubscriptionPauseModal.displayName = "SubscriptionPauseModal";

export default PricingModule(SubscriptionPauseModal);
